/** Max high-priority images on the home page (LCP budget). */
const MAX_HOME_HIGH_PRIORITY = 4;

let highPriorityClaimed = 0;

/** Claim one of the limited high-priority slots for fetchPriority="high". */
export function claimHomeImagePriority(requested: boolean): boolean {
  if (!requested) return false;
  if (highPriorityClaimed >= MAX_HOME_HIGH_PRIORITY) return false;
  highPriorityClaimed += 1;
  return true;
}

export function resetHomeImagePriorityBudget(): void {
  highPriorityClaimed = 0;
}
